import { render, staticRenderFns } from "./Templates.vue?vue&type=template&id=b09aff86&"
import script from "./Templates.vue?vue&type=script&lang=ts&"
export * from "./Templates.vue?vue&type=script&lang=ts&"
import style0 from "./Templates.vue?vue&type=style&index=0&id=b09aff86&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports